































































import { Component, Prop, Vue } from 'vue-property-decorator';
import recipesDB from '../../server/init';
import slugify from 'slugify';
import moment from 'moment';

@Component({})
export default class AddComment extends Vue {
  @Prop({ type: String, default: '' })
  public recipeTitle!: string;

  private errorBlocks: Array<any> = [];
  private formValid: boolean = false;

  private data() {
    return {
      currentRating: null,
      totalRatings: 0,
      averageRating: null,
      recipe: null,
      recipeId: null,
      recipeRating: null,
      recipeReviews: [],
      commentTitle: null,
      commentEmail: null,
      commentTitleError: null,
      commentEmailError: null,
      recipeRatingError: null,
      commentBody: null,
      recipeSlug: null,
      slug: null,
      showBottomSheet: false,
      emptyIcon: 'mdi-beaker-outline',
      fullIcon: 'mdi-beaker',
      halfIncrements: false,
      hover: true,
      length: 5,
      readonly: false,
      size: 36,
      dense: true,
      color: '#0b633e',
      bgColor: '#8c6831',
    };
  }

  private validateEmail() {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(this.$data.commentEmail).toLowerCase());
  }

  private validateRating() {
    if (this.$data.recipeRating === null) {
      this.formValid = false;
      this.$data.recipeRatingError = 'Please enter a rating for this recipe';
    }
  }

  private validateForm() {
    // TODO: verify email address with zero bounce api
    this.validateRating();
    if (!this.validateEmail()) {
      this.$data.commentEmailError = 'Please enter a valid email address';
    } else {
      this.$data.commentEmailError = null;
    }
    if (this.$data.recipeRating !== null && this.validateEmail()) {
      this.formValid = true;
      this.$data.recipeRatingError = null;
      this.$data.commentEmailError = null;
    }
  }

  private validateCommentTitle() {
    if (!this.$data.commentTitle && this.$data.commentBody) {
      this.$data.commentTitleError = 'Please enter a title for your comment.';
      this.errorBlocks.push('comment-title-error');
      this.formValid = false;
    } else {
      this.formValid = true;
      this.$data.commentTitleError = null;
    }
  }

  private closeSheet() {
    this.$emit('closeBottom');
  }

  private scrollToTop() {
    const content = document.getElementById('add-comment');
    if (content != null) {
      content.scrollIntoView({
        block: 'center',
    });
    }
  }

  private getAverageRating() {
    // console.log('current', this.$data.currentRating);
    if (this.$data.currentRating) {
      const rating = this.$data.currentRating + this.$data.recipeRating;
      return this.$data.averageRating = Math.round(rating / 2);
    } else {
      return this.$data.averageRating = this.$data.recipeRating;
    }
  }

  private formatDate(date: string) {
    return moment(String(date)).format('MM/DD/YYYY');
  }

  private addComment() {
    this.validateForm();
    if (this.formValid) {
      if (this.$data.recipeTitle) {
          this.$data.slug = slugify(this.$data.recipeTitle, {
          replacement: '-',
          remove: /[$*_+~.()'"!\-:@]/g,
          lower: true,
        });
      }
      this.getAverageRating();
      this.$data.recipeReviews.push({
        rating: this.$data.recipeRating,
        author: this.$data.commentEmail,
        date: moment().format('MM/DD/YYYY'),
        title: this.$data.commentTitle,
        body: this.$data.commentBody,
        rank: 0,
      });
      recipesDB.collection('recipes').doc(this.$data.recipeId).update({
        reviews: this.$data.recipeReviews,
        rating: this.$data.averageRating,
        slug: this.$data.slug,
        totalRatings: this.$data.totalRatings + 1,
      }).then(() => {
        this.$emit('closeBottom');
        this.$emit('refreshRecipes');
      });
    }
  }

private cancelComment() {
  this.scrollToTop();
  this.closeSheet();
  this.$data.recipeRating = null;
  this.$data.commentTitle = null;
  this.$data.commentBody = null;
  this.$data.commentTitleError = null;
  this.errorBlocks = [];
}

private created() {
  const recipeData = recipesDB.collection('recipes').where('title', '==', this.recipeTitle);
  recipeData.get()
    .then((snapshot) => {
      snapshot.forEach((doc) => {
        this.$data.recipe = doc.data();
        this.$data.recipeId = doc.id;
        this.$data.currentRating = doc.data().rating;
        this.$data.totalRatings = doc.data().totalRatings;
        this.$data.recipe.reviews.forEach((review: object) => {
        this.$data.recipeReviews.push(review);
        });
      });
    });
  }
}
